import React from 'react'
import { StyledInput } from 'spa/member/components/Input/styled'

export type Props = {
  rules?: any,
  inputSize?: 'default' | 'small'
} & React.InputHTMLAttributes<HTMLInputElement>

export const StyledDateInput: React.FC<Props> = props => {
  return (
    <StyledInput
      type='date'
      placeholder='年 / 月 / 日'
      {...props}
      className={`appearance-none ${props.className}`}
      />
  )
}
